
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const PrivacyPolicy = () => {
  useEffect(() => {
    // Load testimonial widget
    const testimonialScript = document.createElement('script');
    testimonialScript.src = 'https://reviewmanagementtool.com/widget.js';
    testimonialScript.onload = function() {
      if (window.TestimonialWidget) {
        window.TestimonialWidget.load('4c920d48-17d6-4b24-be02-a8460961198f');
      }
    };
    document.head.appendChild(testimonialScript);

    // Load social widget
    const socialScript = document.createElement('script');
    socialScript.src = 'https://cdn.reviewmanagementtool.com/widget-static/widget-afe23437-5a8f-4e52-9be9-8e143a855d03.js';
    socialScript.defer = true;
    document.head.appendChild(socialScript);

    return () => {
      // Cleanup: remove scripts on unmount
      const existingTestimonialScript = document.querySelector('script[src="https://reviewmanagementtool.com/widget.js"]');
      if (existingTestimonialScript) {
        existingTestimonialScript.remove();
      }
      
      const existingSocialScript = document.querySelector('script[src="https://cdn.reviewmanagementtool.com/widget-static/widget-afe23437-5a8f-4e52-9be9-8e143a855d03.js"]');
      if (existingSocialScript) {
        existingSocialScript.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Navbar />
      
      <main className="flex-grow container mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto bg-white p-8 rounded-lg shadow-sm">
          {/* ReviewManagementTool Social Widget */}
          <div data-rmt-social-widget="widget-afe23437-5a8f-4e52-9be9-8e143a855d03"></div>
          
          <h1 className="text-3xl font-bold text-gray-900 mb-6">Privacy Policy</h1>
          
          <div className="prose prose-blue max-w-none">
            <p className="text-gray-600 mb-4">
              At CareerGuideKerala.in, we value your privacy. We collect personal information (name, email, 
              contact details) only to provide career guidance and improve user experience.
            </p>
            
            <p className="text-gray-600 mb-4">
              Your data is stored securely and not shared with third parties except as required by law.
            </p>
            
            <p className="text-gray-600 mb-4">
              By using our services, you consent to our data collection and use practices.
            </p>

            <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-3">Information We Collect</h2>
            <p className="text-gray-600 mb-4">
              We may collect the following types of information:
            </p>
            <ul className="list-disc pl-6 mb-4 text-gray-600">
              <li>Personal details (name, email address, phone number)</li>
              <li>Educational information (qualifications, academic history)</li>
              <li>Career preferences and interests</li>
              <li>Assessment responses</li>
              <li>Usage data and website interaction information</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-3">How We Use Your Information</h2>
            <p className="text-gray-600 mb-4">
              We use your information to:
            </p>
            <ul className="list-disc pl-6 mb-4 text-gray-600">
              <li>Provide personalized career guidance services</li>
              <li>Generate assessment reports and recommendations</li>
              <li>Improve our services and user experience</li>
              <li>Communicate important updates about our services</li>
              <li>Process payments for premium services</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-3">Contact Us</h2>
            <p className="text-gray-600 mb-4">
              If you have any questions or concerns about our privacy policy, please contact us at{" "}
              <a href="mailto:careerguidekerala@gmail.com" className="text-brand-blue hover:underline">
                careerguidekerala@gmail.com
              </a>
              .
            </p>
          </div>
        </div>
      </main>
      
      {/* Testimonial Widget */}
      <div className="container mx-auto px-4 py-8">
        <div id="testimonial-widget-4c920d48-17d6-4b24-be02-a8460961198f"></div>
      </div>
      
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
